
import React from "react";
import Modal from "react-bootstrap/Modal";
import { connect, useSelector } from "react-redux";
import { IMAGE_URL, priceunit } from "../../Components/client-config";
import { getComboDetail, getItemDetail, saveCart } from "../../Redux";
import _ from "lodash";
import { Button } from "@mui/material";
import FlyBtn from "./FlyBtn";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { COUNTRY_NAME } from "../../lib";
import { itemReady } from "../../utils/productValidations";

function SuggestiveProductModal(props: any) {
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const orderType = useSelector((state: any) => state.payment.orderType);
  const cartData = useSelector((state: any) => state.cart.cartData);
  const { t } = useTranslation();

  const selectedItem = (item: any) => {
    if (item.suggestive_item_id) {
      props.getItemDetail(orderType, item.suggestive_item_id.menu_item_id, props.handleShow);
      props.closeSuggCompoment()
    }
    if (item.suggestive_combo_id) {
      props.getComboDetail(orderType, item.suggestive_combo_id.combo_id, props.handleComboOpen);
      props.closeSuggCompoment()
    }
  };

  function handleAdd(item: any) {
    if (item.menu_item_id > 0) {
      let selectedSize = item.variants[0];
      let initialPrice = Math.round(selectedSize.mrp);
      let itemPrice = Math.round(selectedSize.mrp);
      let cart: any = cartData;
      const itemcart = {
        item: item,
        quantity: 1,
        selectedsize: selectedSize,
        price: Math.round(initialPrice),
        totalItemPrice: Math.round(itemPrice),
        collapseIn: false,
        is_suggestive_product: true
      };
      cart.push(itemcart);
      props.saveCart(cart);
      if (storeSelected) {
        // props.setHeaderUpdate(props.headerUpdate + 1);
        toast.success(`${item.item_name} ${t("ADDED_TO_CART")}`, {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 3000,
        });
      }
    } else {
      let initialPrice = Math.round(item.combo_mrp_price);
      let itemPrice = Math.round(item.combo_mrp_price);
      let cart: any = cartData;
      const itemcart = {
        combo: item,
        quantity: 1,
        price: Math.round(initialPrice),
        totalItemPrice: Math.round(itemPrice),
        modifiers: item.modifiers,
        collapseIn: false,
        is_suggestive_product: true
      };
      cart.push(itemcart);
      props.saveCart(cart);
      if (storeSelected) {
        // props.setHeaderUpdate(props.headerUpdate + 1);
        toast.success(`${item.combo_name} ${t("ADDED_TO_CART")}`, {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 3000,
        });
      }
    }
  }
  return (
    <div>
      <Modal
        className="modal-sudintive-container"
        show={props.showSuggDeal}
        onHide={() => props.closeSuggCompoment()}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <div className="modal-design">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Modal.Header className="p-0 border-0 justify-content-center">
          <Modal.Title className="font-bold mt-2">
            {!_.isEmpty(props.itemData) && props.itemData.child_products
              ? props.itemData.child_products[0].title
              : props.comboData.child_products[0].title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center mb-0">
            {!_.isEmpty(props.itemData) && props.itemData.child_products
              ? props.itemData.child_products[0].description
              : props.comboData.child_products[0].description}
          </p>
          <div className="p-1">
            <div className="row justify-content-center">
              {/* If Product is Combo */}
              {!_.isEmpty(props.comboData) &&
                props.comboData.child_products &&
                props.comboData.child_products.length > 0 &&
                props.comboData.child_products
                  .filter((obj: any) => {
                    return obj.is_active;
                  })
                  .map((obj: any) => {
                    if (obj.is_lsm == 1) {
                      return (
                        storeSelected &&
                        obj.itemStores.length > 0 &&
                        obj.itemStores.map((obj2: any) => {
                          if (
                            obj2.store_id.store_id == storeSelected.store_id
                          ) {
                            return (
                              obj.suggestive_child_products.length > 0 &&
                              obj.suggestive_child_products
                                .filter((childProduct: any) => {
                                  return childProduct.suggestive_combo_id
                                    ? !cartData.some(
                                      (obj: any) =>
                                        obj.combo &&
                                        obj.combo.combo_id ==
                                        childProduct.suggestive_combo_id.combo_id
                                    ) && childProduct.suggestive_combo_id.is_suggestive
                                    : !cartData.some(
                                      (obj: any) =>
                                        obj.item &&
                                        obj.item.menu_item_id ==
                                        childProduct.suggestive_item_id
                                          .menu_item_id
                                    ) && childProduct.suggestive_item_id.is_suggestive
                                })
                                .map(
                                  (childObj: any) => {
                                    return (
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="col-lg-6 col-10"
                                      >
                                        <div className="item-sugestive-modal-card">
                                          <a
                                            href={`#${childObj.suggestive_combo_id
                                              ? "combo"
                                              : "item"
                                              }/${childObj.suggestive_combo_id
                                                ? childObj.suggestive_combo_id.combo_name.replace(
                                                  /\s+/g,
                                                  ""
                                                )
                                                : childObj.suggestive_item_id?.item_name.replace(
                                                  /\s+/g,
                                                  ""
                                                )
                                              }_${childObj.suggestive_combo_id
                                                ? childObj.suggestive_combo_id
                                                  .combo_id
                                                : childObj.suggestive_item_id
                                                  .menu_item_id
                                              }`}
                                            onClick={() => selectedItem(childObj)}
                                          >
                                            {childObj.suggestive_item_id ? (
                                              <img
                                                src={`${IMAGE_URL}${childObj.suggestive_item_id
                                                  .variants.length > 0 &&
                                                  childObj.suggestive_item_id
                                                    .variants[0].image_url
                                                  }`}
                                                alt="SuggestiveProduct"
                                              />
                                            ) : (
                                              <img
                                                src={`${IMAGE_URL}${childObj.suggestive_combo_id
                                                  .images.length > 0 &&
                                                  childObj.suggestive_combo_id
                                                    .images[
                                                    childObj.suggestive_combo_id
                                                      .images.length - 1
                                                  ].image_url
                                                  }`}
                                                alt="SuggestiveProduct"
                                              />
                                            )}
                                          </a>

                                          <h6>
                                            {childObj.suggestive_item_id
                                              ? childObj.suggestive_item_id
                                                .item_name
                                              : childObj.suggestive_combo_id
                                                .combo_name}
                                          </h6>
                                          <p>
                                            {childObj.suggestive_item_id
                                              ? childObj.suggestive_item_id
                                                .variants.length > 0
                                                ? childObj.suggestive_item_id
                                                  .variants[0].description
                                                  ? childObj.suggestive_item_id
                                                    .variants[0].description
                                                  : `KFC ${COUNTRY_NAME}`
                                                : ""
                                              : childObj.suggestive_combo_id
                                                .description
                                                ? childObj.suggestive_combo_id
                                                  .description
                                                : `KFC ${COUNTRY_NAME}`}
                                          </p>
                                          <h4 className="kfc-price">
                                            {childObj.suggestive_combo_id &&
                                              priceunit +
                                              childObj.suggestive_combo_id
                                                .combo_mrp_price}
                                            {childObj.suggestive_item_id &&
                                              childObj.suggestive_item_id.variants
                                                .length > 0 &&
                                              priceunit +
                                              childObj.suggestive_item_id
                                                .variants[0].mrp}
                                          </h4>
                                          <div className="price-label">
                                            <FlyBtn
                                              closeSuggCompoment={props.closeSuggCompoment}
                                              itemReady={itemReady}
                                              product={
                                                childObj.suggestive_item_id
                                                  ? childObj.suggestive_item_id
                                                  : childObj.suggestive_combo_id
                                              }
                                              handleAdd={handleAdd}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                )
                            );
                          }
                        })
                      );
                    } else if (obj.is_lsm == 0) {
                      return (
                        obj.suggestive_child_products.length > 0 &&
                        obj.suggestive_child_products
                          .filter((childProduct: any) => {
                            return childProduct.suggestive_combo_id
                              ? !cartData.some(
                                (obj: any) =>
                                  obj.combo &&
                                  obj.combo.combo_id ==
                                  childProduct.suggestive_combo_id.combo_id
                              ) && childProduct.suggestive_combo_id.is_suggestive
                              : !cartData.some(
                                (obj: any) =>
                                  obj.item &&
                                  obj.item.menu_item_id ==
                                  childProduct.suggestive_item_id
                                    .menu_item_id
                              ) && childProduct.suggestive_item_id.is_suggestive
                          })
                          .map((childObj: any) => {
                            return (
                              <div
                                style={{ cursor: "pointer" }}
                                className="col-lg-6 col-10"
                              >
                                <div className="item-sugestive-modal-card">
                                  <a
                                    href={`#${childObj.suggestive_combo_id
                                      ? "combo"
                                      : "item"
                                      }/${childObj.suggestive_combo_id
                                        ? childObj.suggestive_combo_id.combo_name.replace(
                                          /\s+/g,
                                          ""
                                        )
                                        : childObj.suggestive_item_id?.item_name.replace(
                                          /\s+/g,
                                          ""
                                        )
                                      }_${childObj.suggestive_combo_id
                                        ? childObj.suggestive_combo_id.combo_id
                                        : childObj.suggestive_item_id
                                          .menu_item_id
                                      }`}
                                    onClick={() => selectedItem(childObj)}
                                  >
                                    {childObj.suggestive_item_id ? (
                                      <img
                                        src={`${IMAGE_URL}${childObj.suggestive_item_id.variants
                                          .length > 0 &&
                                          childObj.suggestive_item_id
                                            .variants[0].image_url
                                          }`}
                                        alt="SuggestiveProduct"
                                      />
                                    ) : (
                                      <img
                                        src={`${IMAGE_URL}${childObj.suggestive_combo_id.images
                                          .length > 0 &&
                                          childObj.suggestive_combo_id.images[
                                            childObj.suggestive_combo_id.images
                                              .length - 1
                                          ].image_url
                                          }`}
                                        alt="SuggestiveProduct"
                                      />
                                    )}
                                  </a>
                                  <h6>
                                    {childObj.suggestive_item_id
                                      ? childObj.suggestive_item_id.item_name
                                      : childObj.suggestive_combo_id.combo_name}
                                  </h6>
                                  <p>
                                    {childObj.suggestive_item_id
                                      ? childObj.suggestive_item_id.variants
                                        .length > 0
                                        ? childObj.suggestive_item_id
                                          .variants[0].description
                                          ? childObj.suggestive_item_id
                                            .variants[0].description
                                          : `KFC ${COUNTRY_NAME}`
                                        : ""
                                      : childObj.suggestive_combo_id.description
                                        ? childObj.suggestive_combo_id.description
                                        : `KFC ${COUNTRY_NAME}`}
                                  </p>
                                  <h4 className="kfc-price">
                                    {childObj.suggestive_combo_id &&
                                      priceunit +
                                      childObj.suggestive_combo_id
                                        .combo_mrp_price}
                                    {childObj.suggestive_item_id &&
                                      childObj.suggestive_item_id.variants
                                        .length > 0 &&
                                      priceunit +
                                      childObj.suggestive_item_id.variants[0]
                                        .mrp}
                                  </h4>
                                  <div className="price-label">
                                    <FlyBtn
                                      closeSuggCompoment={props.closeSuggCompoment}
                                      itemReady={itemReady}
                                      product={
                                        childObj.suggestive_item_id
                                          ? childObj.suggestive_item_id
                                          : childObj.suggestive_combo_id
                                      }
                                      handleAdd={handleAdd}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      );
                    } else if (obj.is_lsm === 2) {
                      let exist = false;
                      return (
                        storeSelected &&
                        obj.itemStores.length > 0 &&
                        obj.itemStores.map((obj2: any) => {
                          if (
                            obj2.store_id.store_id === storeSelected.store_id
                          ) {
                            exist = true;
                          }
                          return null;
                        }),
                        !exist &&
                        obj.suggestive_child_products.length > 0 &&
                        obj.suggestive_child_products
                          .filter((childProduct: any) => {
                            return childProduct.suggestive_combo_id
                              ? !cartData.some(
                                (obj: any) =>
                                  obj.combo &&
                                  obj.combo.combo_id ==
                                  childProduct.suggestive_combo_id.combo_id
                              ) && childProduct.suggestive_combo_id.is_suggestive
                              : !cartData.some(
                                (obj: any) =>
                                  obj.item &&
                                  obj.item.menu_item_id ==
                                  childProduct.suggestive_item_id
                                    .menu_item_id
                              ) && childProduct.suggestive_item_id.is_suggestive
                          })
                          .map((childObj: any) => (
                            <div
                              style={{ cursor: "pointer" }}
                              className="col-lg-6 col-10"
                            >
                              <div className="item-sugestive-modal-card">
                                <a
                                  href={`#${childObj.suggestive_combo_id
                                    ? "combo"
                                    : "item"
                                    }/${childObj.suggestive_combo_id
                                      ? childObj.suggestive_combo_id.combo_name.replace(
                                        /\s+/g,
                                        ""
                                      )
                                      : childObj.suggestive_item_id?.item_name.replace(
                                        /\s+/g,
                                        ""
                                      )
                                    }_${childObj.suggestive_combo_id
                                      ? childObj.suggestive_combo_id.combo_id
                                      : childObj.suggestive_item_id.menu_item_id
                                    }`}
                                  onClick={() => selectedItem(childObj)}
                                >
                                  {childObj.suggestive_item_id ? (
                                    <img
                                      src={`${IMAGE_URL}${childObj.suggestive_item_id.variants
                                        .length > 0 &&
                                        childObj.suggestive_item_id.variants[0]
                                          .image_url
                                        }`}
                                      alt="SuggestiveProduct"
                                    />
                                  ) : (
                                    <img
                                      src={`${IMAGE_URL}${childObj.suggestive_combo_id.images
                                        .length > 0 &&
                                        childObj.suggestive_combo_id.images[
                                          childObj.suggestive_combo_id.images
                                            .length - 1
                                        ].image_url
                                        }`}
                                      alt="SuggestiveProduct"
                                    />
                                  )}
                                </a>

                                <h6>
                                  {childObj.suggestive_item_id
                                    ? childObj.suggestive_item_id.item_name
                                    : childObj.suggestive_combo_id.combo_name}
                                </h6>
                                <p>
                                  {childObj.suggestive_item_id
                                    ? childObj.suggestive_item_id.variants
                                      .length > 0
                                      ? childObj.suggestive_item_id.variants[0]
                                        .description
                                        ? childObj.suggestive_item_id
                                          .variants[0].description
                                        : `KFC ${COUNTRY_NAME}`
                                      : ""
                                    : childObj.suggestive_combo_id.description
                                      ? childObj.suggestive_combo_id.description
                                      : `KFC ${COUNTRY_NAME}`}
                                </p>
                                <h4 className="kfc-price">
                                  {childObj.suggestive_combo_id &&
                                    priceunit +
                                    childObj.suggestive_combo_id
                                      .combo_mrp_price}
                                  {childObj.suggestive_item_id &&
                                    childObj.suggestive_item_id.variants
                                      .length > 0 &&
                                    priceunit +
                                    childObj.suggestive_item_id.variants[0]
                                      .mrp}
                                </h4>
                                <div className="price-label">
                                  <FlyBtn
                                    closeSuggCompoment={props.closeSuggCompoment}
                                    itemReady={itemReady}
                                    product={
                                      childObj.suggestive_item_id
                                        ? childObj.suggestive_item_id
                                        : childObj.suggestive_combo_id
                                    }
                                    handleAdd={handleAdd}
                                  />
                                </div>
                              </div>
                            </div>
                          ))
                      );
                    }
                  })}
              {/* If Product is Item */}

              {!_.isEmpty(props.itemData) &&
                props.itemData.child_products &&
                props.itemData.child_products.length > 0 &&
                props.itemData.child_products
                  .filter((obj: any) => {
                    return obj.is_active;
                  })
                  .map((obj: any) => {
                    if (obj.is_lsm == 1) {
                      return (
                        storeSelected &&
                        obj.itemStores.length > 0 &&
                        obj.itemStores.map((obj2: any) => {
                          if (
                            obj2.store_id.store_id == storeSelected.store_id
                          ) {
                            return (
                              obj.suggestive_child_products.length > 0 &&
                              obj.suggestive_child_products
                                .filter((childProduct: any) => {
                                  return childProduct.suggestive_combo_id
                                    ? !cartData.some(
                                      (obj: any) =>
                                        obj.combo &&
                                        obj.combo.combo_id ==
                                        childProduct.suggestive_combo_id.combo_id
                                    ) && childProduct.suggestive_combo_id.is_suggestive
                                    : !cartData.some(
                                      (obj: any) =>
                                        obj.item &&
                                        obj.item.menu_item_id ==
                                        childProduct.suggestive_item_id
                                          .menu_item_id
                                    ) && childProduct.suggestive_item_id.is_suggestive
                                })
                                .map(
                                  (childObj: any) => {
                                    return (
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="col-lg-6 col-10"
                                      >
                                        <div className="item-sugestive-modal-card">
                                          <a
                                            href={`#${childObj.suggestive_combo_id
                                              ? "combo"
                                              : "item"
                                              }/${childObj.suggestive_combo_id
                                                ? childObj.suggestive_combo_id.combo_name.replace(
                                                  /\s+/g,
                                                  ""
                                                )
                                                : childObj.suggestive_item_id?.item_name.replace(
                                                  /\s+/g,
                                                  ""
                                                )
                                              }_${childObj.suggestive_combo_id
                                                ? childObj.suggestive_combo_id
                                                  .combo_id
                                                : childObj.suggestive_item_id
                                                  .menu_item_id
                                              }`}
                                            onClick={() => selectedItem(childObj)}
                                          >
                                            {childObj.suggestive_item_id ? (
                                              <img
                                                src={`${IMAGE_URL}${childObj.suggestive_item_id
                                                  .variants.length > 0 &&
                                                  childObj.suggestive_item_id
                                                    .variants[0].image_url
                                                  }`}
                                                alt="SuggestiveProduct"
                                              />
                                            ) : (
                                              <img
                                                src={`${IMAGE_URL}${childObj.suggestive_combo_id
                                                  .images.length > 0 &&
                                                  childObj.suggestive_combo_id
                                                    .images[
                                                    childObj.suggestive_combo_id
                                                      .images.length - 1
                                                  ].image_url
                                                  }`}
                                                alt="SuggestiveProduct"
                                              />
                                            )}
                                          </a>
                                          <h6>
                                            {childObj.suggestive_item_id
                                              ? childObj.suggestive_item_id
                                                .item_name
                                              : childObj.suggestive_combo_id
                                                .combo_name}
                                          </h6>
                                          <p>
                                            {childObj.suggestive_item_id
                                              ? childObj.suggestive_item_id
                                                .variants.length > 0
                                                ? childObj.suggestive_item_id
                                                  .variants[0].description
                                                  ? childObj.suggestive_item_id
                                                    .variants[0].description
                                                  : `KFC ${COUNTRY_NAME}`
                                                : ""
                                              : childObj.suggestive_combo_id
                                                .description
                                                ? childObj.suggestive_combo_id
                                                  .description
                                                : `KFC ${COUNTRY_NAME}`}
                                          </p>
                                          <h4 className="kfc-price">
                                            {childObj.suggestive_combo_id &&
                                              priceunit +
                                              childObj.suggestive_combo_id
                                                .combo_mrp_price}
                                            {childObj.suggestive_item_id &&
                                              childObj.suggestive_item_id.variants
                                                .length > 0 &&
                                              priceunit +
                                              childObj.suggestive_item_id
                                                .variants[0].mrp}
                                          </h4>
                                          <div className="price-label">
                                            <FlyBtn
                                              closeSuggCompoment={props.closeSuggCompoment}
                                              itemReady={itemReady}
                                              product={
                                                childObj.suggestive_item_id
                                                  ? childObj.suggestive_item_id
                                                  : childObj.suggestive_combo_id
                                              }
                                              handleAdd={handleAdd}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                )
                            );
                          }
                        })
                      );
                    } else if (obj.is_lsm == 0) {
                      return (
                        obj.suggestive_child_products.length > 0 &&
                        obj.suggestive_child_products
                          .filter((childProduct: any) => {
                            return childProduct.suggestive_combo_id
                              ? !cartData.some(
                                (obj: any) =>
                                  obj.combo &&
                                  obj.combo.combo_id ==
                                  childProduct.suggestive_combo_id.combo_id
                              ) && childProduct.suggestive_combo_id.is_suggestive
                              : !cartData.some(
                                (obj: any) =>
                                  obj.item &&
                                  obj.item.menu_item_id ==
                                  childProduct.suggestive_item_id
                                    .menu_item_id
                              ) && childProduct.suggestive_item_id.is_suggestive;
                          })
                          .map((childObj: any) => {
                            return (
                              <div
                                style={{ cursor: "pointer" }}
                                className="col-lg-6 col-10"
                              >
                                <div className="item-sugestive-modal-card">
                                  <a
                                    href={`#${childObj.suggestive_combo_id
                                      ? "combo"
                                      : "item"
                                      }/${childObj.suggestive_combo_id
                                        ? childObj.suggestive_combo_id.combo_name.replace(
                                          /\s+/g,
                                          ""
                                        )
                                        : childObj.suggestive_item_id?.item_name.replace(
                                          /\s+/g,
                                          ""
                                        )
                                      }_${childObj.suggestive_combo_id
                                        ? childObj.suggestive_combo_id.combo_id
                                        : childObj.suggestive_item_id
                                          .menu_item_id
                                      }`}
                                    onClick={() => selectedItem(childObj)}
                                  >
                                    {childObj.suggestive_item_id ? (
                                      <img
                                        src={`${IMAGE_URL}${childObj.suggestive_item_id.variants
                                          .length > 0 &&
                                          childObj.suggestive_item_id
                                            .variants[0].image_url
                                          }`}
                                        alt="SuggestiveProduct"
                                      />
                                    ) : (
                                      <img
                                        src={`${IMAGE_URL}${childObj.suggestive_combo_id.images
                                          .length > 0 &&
                                          childObj.suggestive_combo_id.images[
                                            childObj.suggestive_combo_id.images
                                              .length - 1
                                          ].image_url
                                          }`}
                                        alt="SuggestiveProduct"
                                      />
                                    )}
                                  </a>
                                  <h6>
                                    {childObj.suggestive_item_id
                                      ? childObj.suggestive_item_id.item_name
                                      : childObj.suggestive_combo_id.combo_name}
                                  </h6>
                                  <p>
                                    {childObj.suggestive_item_id
                                      ? childObj.suggestive_item_id.variants
                                        .length > 0
                                        ? childObj.suggestive_item_id
                                          .variants[0].description
                                          ? childObj.suggestive_item_id
                                            .variants[0].description
                                          : `KFC ${COUNTRY_NAME}`
                                        : ""
                                      : childObj.suggestive_combo_id.description
                                        ? childObj.suggestive_combo_id.description
                                        : `KFC ${COUNTRY_NAME}`}
                                  </p>
                                  <h4 className="kfc-price">
                                    {childObj.suggestive_combo_id &&
                                      priceunit +
                                      childObj.suggestive_combo_id
                                        .combo_mrp_price}
                                    {childObj.suggestive_item_id &&
                                      childObj.suggestive_item_id.variants
                                        .length > 0 &&
                                      priceunit +
                                      childObj.suggestive_item_id.variants[0]
                                        .mrp}
                                  </h4>
                                  <div className="price-label">
                                    <FlyBtn
                                      closeSuggCompoment={props.closeSuggCompoment}
                                      itemReady={itemReady}
                                      product={
                                        childObj.suggestive_item_id
                                          ? childObj.suggestive_item_id
                                          : childObj.suggestive_combo_id
                                      }
                                      handleAdd={handleAdd}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      );
                    }
                    if (obj.is_lsm === 2) {
                      let exist = false;
                      return (
                        storeSelected &&
                        obj.itemStores.length > 0 &&
                        obj.itemStores.map((obj2: any) => {
                          if (
                            obj2.store_id.store_id === storeSelected.store_id
                          ) {
                            exist = true;
                          }
                          return null;
                        }),
                        !exist &&
                        obj.suggestive_child_products.length > 0 &&
                        obj.suggestive_child_products
                          .filter((childProduct: any) => {
                            return childProduct.suggestive_combo_id
                              ? !cartData.some(
                                (obj: any) =>
                                  obj.combo &&
                                  obj.combo.combo_id ==
                                  childProduct.suggestive_combo_id.combo_id
                              ) && childProduct.suggestive_combo_id.is_suggestive
                              : !cartData.some(
                                (obj: any) =>
                                  obj.item &&
                                  obj.item.menu_item_id ==
                                  childProduct.suggestive_item_id
                                    .menu_item_id
                              ) && childProduct.suggestive_item_id.is_suggestive
                          })
                          .map((childObj: any) => (
                            <div
                              style={{ cursor: "pointer" }}
                              className="col-lg-6 col-10"
                            >
                              <div className="item-sugestive-modal-card">
                                <a
                                  href={`#${childObj.suggestive_combo_id
                                    ? "combo"
                                    : "item"
                                    }/${childObj.suggestive_combo_id
                                      ? childObj.suggestive_combo_id.combo_name.replace(
                                        /\s+/g,
                                        ""
                                      )
                                      : childObj.suggestive_item_id?.item_name.replace(
                                        /\s+/g,
                                        ""
                                      )
                                    }_${childObj.suggestive_combo_id
                                      ? childObj.suggestive_combo_id.combo_id
                                      : childObj.suggestive_item_id.menu_item_id
                                    }`}
                                  onClick={() => selectedItem(childObj)}
                                >
                                  {childObj.suggestive_item_id ? (
                                    <img
                                      src={`${IMAGE_URL}${childObj.suggestive_item_id.variants
                                        .length > 0 &&
                                        childObj.suggestive_item_id.variants[0]
                                          .image_url
                                        }`}
                                      alt="SuggestiveProduct"
                                    />
                                  ) : (
                                    <img
                                      src={`${IMAGE_URL}${childObj.suggestive_combo_id.images
                                        .length > 0 &&
                                        childObj.suggestive_combo_id.images[
                                          childObj.suggestive_combo_id.images
                                            .length - 1
                                        ].image_url
                                        }`}
                                      alt="SuggestiveProduct"
                                    />
                                  )}
                                </a>

                                <h6>
                                  {childObj.suggestive_item_id
                                    ? childObj.suggestive_item_id.item_name
                                    : childObj.suggestive_combo_id.combo_name}
                                </h6>
                                <p>
                                  {childObj.suggestive_item_id
                                    ? childObj.suggestive_item_id.variants
                                      .length > 0
                                      ? childObj.suggestive_item_id.variants[0]
                                        .description
                                        ? childObj.suggestive_item_id
                                          .variants[0].description
                                        : `KFC ${COUNTRY_NAME}`
                                      : ""
                                    : childObj.suggestive_combo_id.description
                                      ? childObj.suggestive_combo_id.description
                                      : `KFC ${COUNTRY_NAME}`}
                                </p>
                                <h4 className="kfc-price">
                                  {childObj.suggestive_combo_id &&
                                    priceunit +
                                    childObj.suggestive_combo_id
                                      .combo_mrp_price}
                                  {childObj.suggestive_item_id &&
                                    childObj.suggestive_item_id.variants
                                      .length > 0 &&
                                    priceunit +
                                    childObj.suggestive_item_id.variants[0]
                                      .mrp}
                                </h4>
                                <div className="price-label">
                                  <FlyBtn
                                    closeSuggCompoment={props.closeSuggCompoment}
                                    itemReady={itemReady}
                                    product={
                                      childObj.suggestive_item_id
                                        ? childObj.suggestive_item_id
                                        : childObj.suggestive_combo_id
                                    }
                                    handleAdd={handleAdd}
                                  />
                                </div>
                              </div>
                            </div>
                          ))
                      );
                    }
                  })}
            </div>
            <Button
              onClick={() => props.closeSuggCompoment()}
              variant="contained"
              color="error"
              className="text-center bg-theme"
              style={{ width: "100%" }}
            >
              {t("NO_THANKS")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    saveCart: function (cart: any[]) {
      dispatch(saveCart(cart));
    },
    getItemDetail: (orderType: any, id: any, handleShow:any) => {
      dispatch(getItemDetail(orderType, id, handleShow))
    },
    getComboDetail: (orderType: any, id: any, handleComboOpen:any) => {
      dispatch(getComboDetail(orderType, id, handleComboOpen))
    },
  };
};
export default connect(null, mapDispatchToProps)(SuggestiveProductModal);